import { render } from "./BorderButton.vue?vue&type=template&id=2591bc79&scoped=true"
import script from "./BorderButton.vue?vue&type=script&lang=js"
export * from "./BorderButton.vue?vue&type=script&lang=js"

import "./BorderButton.vue?vue&type=style&index=0&id=2591bc79&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2591bc79"]])

export default __exports__